import styled, { css } from 'styled-components';
import { UiColors } from 'assets/styles/old/global';

export const Root = styled.div`
  position: relative;
  display: inline-flex;
`;

/* Compact icon-only trigger (matches the 40px toolbar controls). */
export const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid ${UiColors.strokeColor};
  border-radius: 8px;
  background: ${({ active }) => (active ? UiColors.cloudColor : UiColors.fillWhiteColor)};
  color: ${UiColors.forestColor};
  cursor: pointer;

  &:hover {
    background: ${UiColors.cloudColor};
  }

  svg {
    width: 17px;
    height: 17px;
  }
`;

export const Menu = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 30;
  min-width: 210px;
  max-height: 320px;
  overflow-y: auto;
  padding: 6px;
  background: ${UiColors.fillWhiteColor};
  border: 1px solid ${UiColors.strokeColor};
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(13, 13, 13, 0.12);
`;

export const MenuLabel = styled.div`
  padding: 4px 8px 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${UiColors.brownColor};
`;

export const Item = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 8px;
  border: none;
  border-radius: 6px;
  background: transparent;
  text-align: left;
  font-size: 13px;
  font-weight: ${({ checked }) => (checked ? 600 : 400)};
  color: ${UiColors.forestColor};
  cursor: pointer;

  &:hover {
    background: ${UiColors.cloudColor};
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

/* Explicit checkbox square so the selected columns read at a glance. */
export const Box = styled.span`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1.5px solid ${UiColors.dimGreyFillColor};
  color: ${UiColors.forestColor};

  svg {
    width: 12px;
    height: 12px;
  }

  ${({ checked }) =>
    checked &&
    css`
      background: ${UiColors.mangoColor};
      border-color: ${UiColors.mangoColor};
    `}
`;
